import {PureComponent} from 'react';

import ChevronIcon from 'Component/ChevronIcon';
import {Directions} from 'Component/ChevronIcon/ChevronIcon.config';
import {DesktopDeliveryMenuComponentProps} from 'Component/DesktopDeliveryMenu/DesktopDeliveryMenu.type';
import SelectedIcon from 'Component/SelectedIcon/SelectedIcon.component';
import {deliveryDateWeekday} from 'SourceQuery/MyAccount.type';
import {ReactElement} from 'Type/Common.type';
import {formattedDate} from 'Util/DateFormat';
import {formatDeliveryDate} from 'Util/DesktopDeliveryMenu';

import './DesktopDeliveryMenu.style.scss';

/** @namespace Steinkrueger/Component/DesktopDeliveryMenu/Component */
export class DesktopDeliveryMenuComponent extends PureComponent<DesktopDeliveryMenuComponentProps> {
    renderDeliveryDateItems(): ReactElement {
        const {
            deliveryDateWeekday,
            opened,
            onAvailableDateMenuClick,
            selectedDeliveryDay,
            isMobile,
        } = this.props;

        const formattedSelectedValue = selectedDeliveryDay ? formattedDate(selectedDeliveryDay) : '';
        const weekDay = selectedDeliveryDay ? formatDeliveryDate(selectedDeliveryDay) : '';
        const iconDirection = opened ? Directions.LEFT : Directions.RIGHT;
        const mobileView = isMobile;

        if (isMobile) {
            return (
                <>
                    <button
                      id="HeaderAvailableDateButton"
                      block="HeaderAvailableDate"
                      elem="Button"
                      key="HeaderAvailableDateButton"
                    >
                        <span block="HeaderAvailableDate" elem="Title">{ __('Delivery Day Preselection') }</span>
                        <div block="HeaderAvailableDate" elem="Date">
                            <div>
                                <strong>{ __(weekDay) }</strong>
                                <span>{ formattedSelectedValue }</span>
                            </div>
                        </div>
                    </button>
                    <div block="DeliveryDate">
                        <div block="DeliveryDate" elem="Items">
                            { deliveryDateWeekday.map(this.renderDeliveryDateItem.bind(this)) }
                        </div>
                    </div>
                </>
            );
        }

        return (
            <>
                <button
                  id="HeaderAvailableDateButton"
                  block="HeaderAvailableDate"
                  elem="Button"
                  mods={ {opened, mobileView} }
                  key="HeaderAvailableDateButton"
                  onClick={ onAvailableDateMenuClick }
                >
                    <span block="HeaderAvailableDate" elem="Title">{ __('Delivery Day Preselection') }</span>
                    <div block="HeaderAvailableDate" elem="Date">
                        <div>
                            <strong>{ __(weekDay) }</strong>
                            <span>{ formattedSelectedValue }</span>
                        </div>
                        <ChevronIcon direction={ iconDirection } />
                    </div>
                </button>
                { opened && (
                    <div block="DeliveryDate">
                        <div block="DeliveryDate" elem="Items">
                            { deliveryDateWeekday.map(this.renderDeliveryDateItem.bind(this)) }
                        </div>
                    </div>
                ) }
            </>
        );
    }

    renderDeliveryDateItem(item: deliveryDateWeekday): ReactElement {
        const {
            handleDeliveryDate,
            selectedDeliveryDay,
        } = this.props;

        const { weekday, is_available } = item;

        const date = weekday.toString();
        const weekDay = formatDeliveryDate(date);
        const formattedDeliveryDate = formattedDate(date);
        const isSelected = formattedDeliveryDate === formattedDate(selectedDeliveryDay);

        return (
            <button
                // eslint-disable-next-line react/jsx-no-bind
              onClick={ (e) => handleDeliveryDate(e, date, weekday) }
              block="Button DeliveryDate"
              elem="Item"
              mods={ { isSelected } }
              disabled={ !is_available }
              key={ weekday }
            >
                { isSelected && <SelectedIcon /> }
                <span>{ __(weekDay) }</span>
                <span block="DeliveryDate" elem="Day">{ formattedDeliveryDate }</span>
            </button>
        );
    }

    render() {
        return (
            <div block="DesktopDeliveryMenu" elem="Wrapper">
                { this.renderDeliveryDateItems() }
            </div>
        );
    }
}

export default DesktopDeliveryMenuComponent;
